/*
 * @Author: ht 1724552153@qq.com
 * @Date: 2024-08-05 13:56:40
 * @LastEditors: ht 1724552153@qq.com
 * @LastEditTime: 2025-07-08 09:35:56
 * @FilePath: \jisuapp_webapp\src\chatgpt-page\pc-index\PcIndex.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDom from 'react-dom';
import "./PcIndex.less";
import { ajax } from '@utils/http';
import lrz from 'lrz';
import { appMethod as app } from '@utils/app';
import OfficialPage from '../../official-page/OfficialPage';
import { Toast,Switch } from 'antd-mobile';
import TextAnimationPc from "../component/TextAnimationPc/TextAnimationPc";
import IntegralDetail from "../component/IntegralDetail/IntegralDetail";
import OrderList from "../component/OrderList/OrderList";
import VipRecharge from "../component/VipRecharge/VipRecharge";
import PaySuccess from "../component/PaySuccess/PaySuccess";
import IntegralRecharge from "../component/IntegralRecharge/IntegralRecharge";
import RechargeCenter from "../component/RechargeCenter/RechargeCenter";
import MemoryBank from "../component/MemoryBank/MemoryBank"
import Dialog from "../dialog/Dialog";

const GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4',
  '2': '文心一言-4.0',
  '3': 'GPT-4omini',
  '4': '通义千问',
  '5': 'kimi',
  '6': 'GPT-4o',
  '7': '字节豆包',
  '8': '百川智能',
  '9': 'GPT-o1-preview',
  '10': 'GPT-o1-mini',
  '11': '腾讯混元',
  '12': '讯飞星火-Max',
  '13': 'Azure-OpenAI',
  '14': 'deepseek（官网）',
  '15': 'deepseek（腾讯云版本）',
  '16': 'UI TARS',
  '17': 'GPT-o3-mini',
  '18': 'GPT-o4-mini',
  '19': '通义千问3',
  '20': 'deepseek-r1'
}
export default class PcIndex extends OfficialPage {
  state = {
    canUseIntegral: 0,
    userInfo: {},
    historyList: [],
    historyNum: 0,
    historyTitled: '',
    roleList: [
      {
        role_id: '0',
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }
    ],
    roleListAll: [],
    selectedRoleId: '',
    selectedRoleName: '',
    selectedRoleLLM: '',
    selectedRolePrologue: '',
    sessionId: '', //会话id
    dialogueList : [],
    is_more: 0,
    current_page: 1,
    content: '', //提问内容
    isSub: false,
    userVipCardInfo: null,
    memoryDialogShow:false,// 记忆弹窗
    integralDialogShow: false, // 积分列表弹窗
    orderDialogShow: false, // 订单列表弹窗
    integralRechargeShow: false, // 积分充值弹窗
    vipRechargeShow: false, // 会员充值弹窗

    vipShow: false, // 会员开通套餐
    paySuccessShow: false,
    rechargeCenterShow: false,
    modalType: 0, // 模型
    modalName: 'GPT-3.5', // 模型名称
    modalId: '',
    modalList: [],
    isShowModalConfig: false,
    isRefreshPosition: true,
    isQuestioning: false, // 正在提问中
    isShowAllRole: false,
    searchValue: '',
    isShowAside: true,
    isNeedVip: false,
    isNeedIntegral: false,
    freeNum: 0,
    filesList: [],
    // isStorageVisible:false,//显示多选框
    // isAllStorage:false,//全选
    isShowFunList: false,
    funList: [],

    deepSwitch:false, // 深度解析开关
    is_use_cot:false  // 是否显示深度解析开关
  }
  constructor(props) {
    super(props);
    document.title = '即速对话';
    this.myRef = React.createRef();
    this.heRef = React.createRef();
    this.fileInputRef = React.createRef();
  }
  componentDidMount() {
    app.globalData.homepageRouter = 'jisuSession'; //将首页路径设置为gpt入口页
    if (!app.isLogin()) {
      app.turnToPage('login-pc');
      return;
    }
    this.setData({
      userInfo: app.getUserInfo()
    })
    this.getIntegralDetailData();
    this.getIntegralInfo();
    this.getUserAskQues();
    this.getRoleList();
    this.getHistoryList();
    this.getVipInfo();
    this.getUserAiModel();
  }
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  debubbling = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }
  logout = () => {
    Dialog.showModal({
      title: '确定要退出登录?',
      confirm: () => {
        app.sendRequest({
          url: '/index.php?r=AppUser/logout',
          success: () => {
            app.setIsLogin(false);
            app.turnToPage('login-pc');
            app.removeStorage({key: 'nowSessionData'})
            app.removeStorage({key: 'userInfo'})
          }
        })
      },
    })
  }
  // 获取会员信息
  getVipInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=appVipCard/getUserAccountSurvey',
      data: {
        app_id: app.getAppId(),
        card_type: 2
      },
      hideLoading: true,
      success: (res) => {
       if(res.status == 0){
        that.setState({
          userVipCardInfo: res.data.user_paid_vip_card,
          isNeedVip: Boolean(res.data.all_vip_card.length),
        })
        this.getSupportTypeSet();
       }
      }
    })
  }
  // 获取积分信息
  getIntegralDetailData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      success: function (res) {
        if(res.status != 0){return}
        that.setState({
          canUseIntegral: res.data.can_use_integral
        })
      }
    })
  }
  getUserAskQues = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetUserAskQues',
      success: function (res) {
        if(res.status != 0){return}
        that.setState({
          freeNum: Number(res.data)
        })
      }
    })
  }

  getIntegralInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
      hideLoading: true,
      data: {
        app_id: app.getAppId(),
        card_type: 2
      },
      success: (res) => {
        if(res.status != 0){return}
        that.setState({
          isNeedIntegral: Boolean(res.data.length)
        })
      }
    })
  }
  // 获取角色
  getRoleList = () => {
    let that = this;
    // 初始化 
    let currentSessionId = '';
    let currentRoleId = '';
    let currentRoleName = '';
    let currentRoleLLM = '';
    that.setData({
      roleList: [
        {
          role_id: 0,
          role_name: '会话',
          url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
        }
      ],
    })
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetRole',
      data: {
        app_id: app.getAppId(),
      },
      method: 'POST',
      success: function (res) {
        app.hideLoading();
        let user_roles = res.data.user_roles || [];
        let roleList = [...that.data.roleList,...user_roles,...res.data.system_role];
        roleList.forEach((item) => {
          if(item.id){
            item.role_id = item.id
          }
          if(item.title){
            item.role_name = item.title
          }
          if(item.is_default == '1'){ //设置了默认对话时
            currentRoleId = item.id
          }
        })
        that.setData({
          roleList: roleList,
          roleListAll: roleList,
        })
        // 从左侧历史对话进入
        if(that.data.sessionId && that.data.selectedRoleId){ 
          currentSessionId = that.data.sessionId;
          currentRoleId = that.data.selectedRoleId;
          currentRoleName = that.data.selectedRoleName;
          currentRoleLLM = that.data.selectedRoleLLM;
        }else{ // 获取历史当前打开的历史对话页
          let getSt = app.getStorageSync('nowSessionData');
          if(getSt){
            currentSessionId = getSt.sessionId;
            let session = that.data.roleList.filter(item=> item.role_id == getSt.roleId)[0]
            // console.log(session)
            currentRoleId = session.role_id;
            currentRoleName = session.role_name || session.title;
            currentRoleLLM = session.llm_type;
          }
        }
        that.setData({
          sessionId: currentSessionId,
          selectedRoleId: currentRoleId,
          selectedRoleName: currentRoleName,
          selectedRoleLLM: currentRoleLLM
        })
        that.getFunList();
        if(currentSessionId){
          that.getSessionHistory({
            session_id: currentSessionId,
            page: that.data.current_page,
          })
        }
      }
    })
  }
  //获取开场白 
  getPrologue = () => {
    let roleList = this.state.roleList;
    let currentRoleId = this.state.selectedRoleId
    // 获取开场白
    let prologueData =  roleList.filter((item) => currentRoleId == item.id || currentRoleId == item.role_id)[0];
    let prologue = prologueData.prologue || ''; //prologueData.content
    let ques = prologueData.opening_ques && (typeof prologueData.opening_ques === 'string' ? JSON.parse(prologueData.opening_ques) : prologueData.opening_ques) || []
    let dialoguearr = this.state.dialogueList;
    if(prologue){
      dialoguearr.unshift({ // 将开场白插入对话
        text: prologue,
        direction: 'reply',
        id: '0000',
        isHistory: true,
        quesList: !dialoguearr.length && ques,
        // isStorageFlag:false
        // 是否显示深度解析
        showDeep:0
      })
    }
    this.setData({
      selectedRolePrologue: prologue,
      dialogueList: dialoguearr,
      is_use_cot:prologueData.is_use_cot == 1 ? true : false
    })
  }
  // 获取历史对话列表
  getHistoryList = () => {
    let that = this;
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/SessionList',
      data: {
        app_id: app.getAppId(),
        page: -1,
        page_size: 1
      },
      method: 'POST',
      success: function (res) {
        app.hideLoading();
        let hisArr = res.data.map(item => {
          if(!item.content){
            item.content = '暂无对话'
          }
          item.isEdit = false;
          item.isDel = false
          return item
        })
        that.setData({
          historyList: hisArr,
          historyNum: res.data.length,
          historyTitled: ''
        })
      }
    })
  }
  goHistoryDetail = event => {
    let that = this;
    let id = event.currentTarget.dataset.id;
    let rid = event.currentTarget.dataset.rid;
    let session = that.data.roleList.filter(item=> item.role_id == rid)[0];
    let rname = session.role_name || session.title;
    this.setData({
      selectedRoleId: rid,
      selectedRoleName: rname,
      sessionId: id,
      dialogueList: []
    })
    app.setStorage({
      key: 'nowSessionData',
      data: {
        sessionId: id,
        roleId: rid
      }
    })
    this.getSessionHistory({
      session_id: id,
      page: that.data.current_page,
    })
  }
  edit = event => {
    this.debubbling(event);
    let id = event.currentTarget.dataset.id;
    let title;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        item.isEdit = true;
        title = item.content;
      }else{
        item.isEdit = false;
      }
      return item;
    })
    this.setData({
      historyList: hisArr,
      historyTitled: title
    })
  }
  bindHisInput = (event) => {
    let val = event.target.value;
    let id = event.currentTarget.dataset.id;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        item.content = val;
      }
      return item;
    })
    this.setData({
      historyList: hisArr,
    })
  }
  conf = event => {
    this.debubbling(event);
    let that = this
    let id = event.currentTarget.dataset.id;
    let val = event.currentTarget.dataset.val;
    if(val == ''){
      Toast.info('对话标题不能为空');
      that.getHistoryList();
      return
    }
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/UpdateSessionTitle',
      data: {
        app_id: app.getAppId(),
        id: id,
        title: val
      },
      method: 'POST',
      complete: function (res) {
        if(!res.status){ 
          app.hideLoading();
          that.getHistoryList();
        }
      }
    })
  }
  noConf = event => {
    this.debubbling(event);
    // this.getHistoryList();
    let id = event.currentTarget.dataset.id;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        if(item.content == this.state.historyTitled){
          item.isEdit = false;
        }else{
          item.isEdit = false;
          item.content = this.state.historyTitled;
        }
      }
      return item;
    })
    this.setData({
      historyList: hisArr,
      historyTitled: ''
    })
  }
  preDel = event => {
    this.debubbling(event);
    let id = event.currentTarget.dataset.id;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        item.isDel = true;
      }
      return item;
    })
    this.setData({
      historyList: hisArr
    })
  }
  cancelPreDel = event => {
    event.stopPropagation();
    let id = event.currentTarget.dataset.id;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        item.isDel = false;
      }
      return item;
    })
    this.setData({
      historyList: hisArr
    })
  }
  delect = event => {
    event.stopPropagation();
    let id = event.currentTarget.dataset.id;
    let that = this;
    app.sendRequest({
      url: '/index.php?r=ChatAI/CreateSession',
      data: {
        app_id: app.getAppId(),
        is_deleted: 1,
        id: id
      },
      hideLoading: true,
      method: 'POST',
      success: function (res) {
        if(res.status == 0){
          Toast.info('删除完成');
          if(id == that.data.sessionId){
            app.removeStorage({key: 'nowSessionData'})
            that.setData({
              selectedRoleId: '',
              selectedRoleName: '',
              selectedRoleLLM: '',
              sessionId: '',
              dialogueList: []
            })
          }
          that.getHistoryList();
        }
      }
    })
  }
  // 创建会话
  creatSession = (id = null) => {
    let that = this;
    return new Promise((resolve, reject) => {
      let parms = {
        app_id: app.getAppId(),
      }
      if(id || that.data.selectedRoleId){
        parms['role_play_id'] = id || that.data.selectedRoleId;
      }
      app.sendRequest({
        url: '/index.php?r=ChatAI/CreateSession',
        data: parms,
        hideLoading: true,
        method: 'POST',
        complete: function (res) {
          if(res.status == 0){
            app.setStorage({
              key: 'nowSessionData',
              data: {
                sessionId: res.data,
                roleId: id?id:(that.data.selectedRoleId || 0)
              }
            })
            that.setData({
              sessionId: res.data,
              dialogueList : [],
              roleList: [
                {
                  role_id: 0,
                  role_name: '会话',
                  url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
                }
              ],
            })
            that.getRoleList();
            that.getHistoryList();
            resolve(res.data);
          }else{
            reject();
          }
        }
      })
    })
  }
  // 开启新对话
  startNewSession = () => {
    let that = this;
    if(this.state.historyNum >= 4 && !this.state.userVipCardInfo){
      if(!this.state.isNeedVip){
        Dialog.showModal({
          title: '会话已达上限',
          confirm: () => {}
        })
        return
      }
      Dialog.showModal({
        title: '会话已达上限',
        content: '请删除重新创建或开通会员',
        confirmText: '开通会员',
        confirm: () => {
          that.renewVip();
        },
      })
      return
    }
    if(!this.state.dialogueList.length){
      Toast.info('已是最新对话')
      return
    }
    app.showLoading({
      title: '加载中..',
    })
    that.creatSession();
  }
  // 选中角色
  selectActiveItem = event => {
    let that = this
    let id = event.currentTarget.dataset.id;
    if(this.state.historyNum > 3 && !this.state.userVipCardInfo){
      if(!this.state.isNeedVip){
        Dialog.showModal({
          title: '会话已达上限',
          confirm: () => {}
        })
        return
      }
      Dialog.showModal({
        title: '会话已达上限',
        content: '请删除重新创建或开通会员',
        confirmText: '开通会员',
        confirm: () => {
          that.renewVip();
        },
      })
      return
    }
    let session = that.data.roleList.filter(item => item.role_id == id || item.id == id)[0];
    let title  = session.role_name || session.title;
    Dialog.showModal({
      title: '是否切换对话角色为'+ title,
      confirm: () => {
        that.setData({
          selectedRoleId: session.role_id,
          selectedRoleName: title,
          selectedRoleLLM: session.llm_type,
          dialogueList : [],
          is_more: 0,
          isShowAllRole: false,
          searchValue: '',
          roleListAll: that.data.roleList
        })
        if(id == 0 || id == '0'){ //普通会话
          app.removeStorage({key: 'nowSessionData'})
          that.creatSession();
          return
        }
        that.creatSession(id);
        that.getFunList();
      },
    })
  }

  bindTextInput = (event) => {
    const textarea = document.getElementById('auto-resize-textarea');
    function autoResize() {
      textarea.style.height = 'auto'; // 重置高度
      textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`; // 动态调整高度，不超过最大高度
    }
    // 初始调用一次以确保初始状态正确
    autoResize();
    let val = event.target.value;
    if(val){
      this.setData({
        isSub: true
      });
    }else{
      this.setData({
        isSub: false
      });
    }
    this.setData({
      'content': val,
    });
  }
  // 获取会话聊天记录
  getSessionHistory = (option,ismore = false,hideloading = false) => {
    return new Promise((resovle) => {
      let diaArr = this.state.dialogueList;
      let that = this;
      if (option.page = 1) {
        diaArr = [];
      }
      app.showLoading({
        title: '加载中..',
      })
      app.sendRequest({
        url: '/index.php?r=ChatAI/SessionChatList',
        hideLoading: hideloading,
        method: 'POST',
        data: {
          app_id: app.getAppId(),
          page_size: 20,
          ...option
        },
        success: function(res) {
          if(res.status == 0){
            if(res.data.length){
              resovle(res.data[0].id)
            }
            if(ismore){ // 从顶部插入
              let data = res.data.reverse();
              for(let j = data.length-1; j >= 0; j--){
                // diaArr.unshift({
                //   text: data[j].content,
                //   direction: data[j].role == '0' ? 'ques':'reply',
                //   id: data[j].id,
                //   isHistory: true,
                //   type: data[j].type,
                //   chunks:data[j].reference.chunks
                // })
                let item = {
                  text: data[j].content.replace(/\\n/g, '\n'),
                  direction: data[j].role == '0' ? 'ques' : 'reply',
                  id: data[j].id,
                  isHistory: true,
                  type: data[j].type,
                  reference_url: data[j].reference_url,
                  files: res.data[j].role == '0' ? (res.data[j].multi_content_struct || []) : [],
                  // 深度思考
                  showDeep: 0,
                  // isStorageFlag:false
                };
                if (data[j].reference && data[j].reference.chunks) {
                  item.chunks = data[j].reference.chunks;
                }
                diaArr.unshift(item);
              }
            }else{
              for(let i = res.data.length-1; i >= 0; i--){
                // diaArr.push({
                //   text: res.data[i].content,
                //   direction: res.data[i].role == '0' ? 'ques':'reply',
                //   id: res.data[i].id,
                //   isHistory: true,
                //   type: res.data[i].type,
                //   chunks:res.data[i].reference.chunks
                // })
                let item = {
                    text: res.data[i].content.replace(/\\n/g, '\n'),
                    direction: res.data[i].role == '0' ? 'ques':'reply',
                    id: res.data[i].id,
                    isHistory: true,
                    type: res.data[i].type,
                    reference_url:res.data[i].reference_url,
                    files: res.data[i].role == '0' ? (res.data[i].multi_content_struct || []) : [],
                  // 是否显示深度思考
                  showDeep:0,
                    // isStorageFlag:false
                }
                if (res.data[i].reference && res.data[i].reference.chunks) {
                  item.chunks = res.data[i].reference.chunks;
                }
                diaArr.push(item);
              }
            }
            that.setData({
              dialogueList: diaArr,
              is_more:res.is_more,
              current_page: res.current_page || 1
            }) 
            that.getPrologue();
            const dialogEle  = ReactDom.findDOMNode(that.myRef.current); 
            // 聊天记录聚焦最新会话 
            if(!ismore){
              dialogEle.scrollTop = dialogEle.scrollHeight;
            }
          }
        }                   
      })
    })  
  }
  // 点击加载更多
  getMore = () => {
    this.getSessionHistory({
      session_id: this.data.sessionId,
      page: this.data.current_page+1,
    },true)
  }
  // 
  tipsModalFn = () => {
    let {isNeedVip, isNeedIntegral, userVipCardInfo, canUseIntegral, freeNum} = this.state;
    let dsc = '';
    let confirmText = '';

    if(isNeedVip && isNeedIntegral && !userVipCardInfo && canUseIntegral < 2){
      dsc = '积分不足，请先购买会员或积分';
    }else
    if(isNeedVip && !isNeedIntegral && !userVipCardInfo && canUseIntegral < 2 && freeNum < 1){
      dsc = '提问次数不足，去开通会员';
      confirmText = '去开通';
    }else
    if(!isNeedVip && isNeedIntegral && canUseIntegral < 2){ 
      dsc = '积分不足，去购买积分';
      confirmText  = '去购买';
    }else
    if(!isNeedVip && !isNeedIntegral && canUseIntegral < 2  && freeNum < 1){
      dsc = '提问次数不足'; 
      confirmText  = '确定';
    }else{

      return
    }
    Dialog.showModal({
      title: dsc,
      confirmText: confirmText,
      confirm: () => {
        that.renewVip();
      },    
    }) 
  }
  goQuestion = (option) => {
    let that = this;
    let diaArr = this.state.dialogueList;
    let question = option.question;
    const oldId = diaArr.length && Number(diaArr[diaArr.length-1].id) || 0; // 暂存最后对话的id,没有就对话时赋值0
    this.tipsModalFn();
    diaArr.push({
      text: that.data.content,
      direction: 'ques',
      id: new Date().getTime(), // 生成一个虚拟id
      isLoading: true,
      files: JSON.parse(option.multi_content)
    })
    that.setData({
      dialogueList: diaArr,
      content: '',
      isQuestioning: true,
    })
    let dialogEle  = ReactDom.findDOMNode(that.myRef.current);
    let scrollTimer = setTimeout(()=>{
      dialogEle.scrollTop = dialogEle.scrollHeight;
      clearTimeout(scrollTimer)
    })
    app.sendRequest({
      hideLoading: true,
      hideModal: true,
      url: '/index.php?r=ChatAI/AskQues',
      method: 'POST',
      timeout: 60000,
      data: {
        app_id: app.getAppId(),
        role_id: this.state.selectedRoleId,
        ...(this.state.deepSwitch ? { is_use_cot: 1 } : {}),
        scene:3,
        ...option
      },
      complete: function(res) {
        if(!res && oldId){ // 请求超时时，轮询获取聊天记录
          let num = 0;
          that.endQuestion()
          let getNewTimer = setInterval(() => {
            num++
            that.getSessionHistory({
              session_id: that.data.sessionId,
              page: 1,
            },false,true).then((newId) => {
              if(Number(newId) > oldId){
                clearInterval(getNewTimer)
              }else if(num >= 7){
                clearInterval(getNewTimer)
                that.setData({
                  content: question,
                  isSub: true,
                  isQuestioning: false,
                })
                Dialog.showModal({
                  title: '看来你的请求超时了',
                  content:'敬请原谅,请稍候再试。。。',
                });
              }
            })
          },3000)
        }else{
          if(res.status == 0 && res.data.response && typeof res.data.response == 'string'){
            diaArr[diaArr.length - 1].isLoading = false;
            // diaArr.push({
            //   text: res.data.response,
            //   direction: 'reply',
            //   id: res.data.id,
            //   type: option.type,
            //   chunks: res.data.reference.chunks
            // })
            let item = {
                text: res.data.response.replace(/\\n/g, '\n'),
                direction: 'reply',
                id: res.data.result.id,
                type: option.type,
                // isStorageFlag:false
                // 是否显示深度思考
                showDeep: res.data.result.choices[0].message.reasoning_content !== undefined ? 1 : 0,
                showDeepContent: false,
                reasoningContent: res.data.result.choices[0].message.reasoning_content || '',
                reasoningFinsh: false
            }
            if (res.data.reference && res.data.reference.chunks) {
              item.chunks = res.data.reference.chunks;
            }
            diaArr.push(item);
            that.setData({
              dialogueList: diaArr,
              filesList: []
            })
            that.getIntegralDetailData(); //更新积分信息
          }else{
            console.log(3333)
            diaArr[diaArr.length - 1].isLoading = false;
            diaArr[diaArr.length - 1].err = true;
            Dialog.showModal({
              title: '对话异常',
              content: res.data,
              confirm: function () {}
            });
            that.endQuestion()
          }
          that.setData({
            content: '',
            isSub: false,
            isQuestioning: false,
          })
        }
        scrollTimer = setTimeout(()=>{
          dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
          clearTimeout(scrollTimer)
        })
      },
    })
  }
  // 提问
  askQuestions = () => {
    let {content ,sessionId, isSub, isQuestioning, filesList} = this.state;
    let that = this;
    if(!isSub || isQuestioning){
      return;
    }
    let filesInfo = [];
    if (filesList.length) {
      content = !content ? '帮我将这些文件的内容总结一下' : content;
      filesList.forEach(item => {
        filesInfo.push({
          type: item.type !== 'image' ? 'corpus_file' : 'image',
          name: item.name,
          file_url: item.url,
          size: item.size,
          file_type: item.type,
        })
      });
      this.comfirmFile(filesInfo)
      this.setData({
        content: content
      })
    }
    console.log(that.data.selectedRoleId)
    if(sessionId == '' || sessionId == 0){
      that.creatSession().then( id => {
        that.goQuestion({
          session_id: id,
          question: content,
          type: that.state.modalType,
          scene:3,
          multi_content: JSON.stringify(filesInfo),
          role_id:that.data.selectedRoleId,
          type: that.state.selectedRoleLLM || that.state.modalType
        })
      });
    }else{
      that.goQuestion({
        session_id: sessionId,
        question: content,
        type: that.state.modalType,
        scene:3,
        role_id:that.data.selectedRoleId,
        type: that.state.selectedRoleLLM || that.state.modalType,
        multi_content: JSON.stringify(filesInfo)
      })
    }
  }
  askQuestionsKeyEnter = (e) => {
    if(e.key === 'Enter' && !e.shiftKey){
      e.preventDefault();
      this.askQuestions();
    }else if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      this.setData({
        content: this.data.content + "\n"
      })
    }
  }
  cancelDialog = (type,ispays) => {
    this.setData({
      [`${type}Show`]: false
    })
    if(ispays) { //支付成功弹窗
      this.setState({
        paySuccessShow: true
      })
    }
    if(type == 'rechargeCenter') {
      this.getVipInfo();
      this.getIntegralDetailData(); 
    }
  }
  // 侧边导航
  clickNav = event => {
    let type = event.currentTarget.dataset.type;
    this.setData({
      [`${type}Show`]: true,
      isShowModalConfig: false
    })
  }
  // 充值
  renewVip = () => {
    this.setData({
      rechargeCenterShow: true
    })
  }
  // 重新发送
  againSend = (data, isQues) => {
    let list = JSON.parse(JSON.stringify(this.data.dialogueList));
    this.setData({
      content: data,
      isSub: true,
    });
    if (isQues) {
      delete list[0].quesList;
      this.setData({
        dialogueList: list
      });
    } else {
      list.pop();
      this.setData({
        dialogueList: list
      })
    }
    this.askQuestions();
  }
  // 展示 深度解析下拉
  showDeepChange = ids =>{
    const newDialogueList = this.data.dialogueList.map(item => {
      if (item.id === ids) {
        return {
          ...item,
          showDeepContent: !item.showDeepContent
        };
      }
      return item;
    })
    this.setData({
      dialogueList:newDialogueList
    })
  }
  // 深度解析完成
  showDeepFinshed = id =>{
    const newDialogueList = this.data.dialogueList.map(item => {
      if (item.id === id) {
        return {
          ...item,
          reasoningFinsh: true
        };
      }
      return item;
    })
    this.setData({
      dialogueList:newDialogueList
    })
  }
  //聚焦优化
  handleScroll = () => {
    let dialogTop = this.myRef.current.childNodes[this.myRef.current.childNodes.length - 1].getBoundingClientRect().top;
    let toolTop = this.heRef.current.getBoundingClientRect().top;
    if(dialogTop > toolTop){
      this.setData({
        isRefreshPosition: false
      })
    }else{
      this.setData({
        isRefreshPosition: true
      })
    }
  }
  // 聊天记录聚焦最新会话
  toBoxBottom = () => {
    if(this.data.isRefreshPosition){
      let dialogEle  = ReactDom.findDOMNode(this.myRef.current);
      let scrollTimer = setTimeout(()=>{
        dialogEle.scrollTop = dialogEle.scrollHeight;
        clearTimeout(scrollTimer)
      })
    }
  }
  endQuestion = () => {
    this.setData({
      isQuestioning: false
    })
  }
  // 获取所有配置模型
  // getGetChatConfig = () => {
  //   let that = this;
  //   app.sendRequest({
  //     hideLoading: true,
  //     url: '/index.php?r=pc/ChatAI/GetChatConfig',
  //     method: 'POST',
  //     data: {
  //       app_id: app.getAppId(),
  //       type: -1
  //     },
  //     success: function(res) {
  //       that.setData({
  //         modalList: res.data,
  //         modalName: GPTModal[res.data[0].type],
  //         modalType: res.data[0].type
  //       })
  //     }
  //   })
  // }
  // 获取模型选择
  getUserAiModel = () => { 
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=ChatAI/GetUserAiModel',
      method: 'POST',
      data: {
        app_id: app.getAppId(),
      },
      success: function(res) {
        if(res.status == 0){
          that.setData({
            modalType: res.data,
            modalName: GPTModal[res.data],
            modalId: res.data,
          })
        }
      }
    })
  }
  // 切换模型
  changeAiModel = (type) => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=ChatAI/ChangeAiModel',
      method: 'POST',
      data: {
        app_id: app.getAppId(),
        model_type: type
      },
      success: function(res) {
        if(res.status == 0){
          Toast.info('切换完成');
          that.getUserAiModel();
          that.setData({
            isShowModalConfig: false
          })
        }
      }
    })
  }
  // 获取可用的配置模型
  getSupportTypeSet = () => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=ChatAI/GetSupportTypeSet',
      method: 'POST',
      data: {
        app_id: app.getAppId(),
      },
      success: function(res) {
        if(res.data.length){
          let list = res.data.map((item) => {
            if(that.state.isNeedVip){
              return res[item]
            }else{
              // if(res[item]?.require_vip_permission != '1'){
              //   return res[item]
              // }
              if (res[item] && res[item].require_vip_permission !== '1') {
                return res[item];
              }
            }
          }).filter(value => value !== undefined);
          that.setData({
            modalList: list,
          })
        }
      }
    })
  }
  selectModal = (event) => {
    let that = this;
    let type = event.currentTarget.dataset.type;
    let isvip = event.currentTarget.dataset.isvip;
    if(Number(isvip) && !this.state.userVipCardInfo){
      this.setData({
        isShowModalConfig: false
      })
      Dialog.showModal({
        title: '请开通会员',
        confirmText: '开通会员',
        confirm: () => {
          that.renewVip();
        },
      })
      return
    }
    this.changeAiModel(type);
  }
  showSelectModalBox = () => {
    this.setData({
      isShowModalConfig: !this.data.isShowModalConfig
    })
  }
  showAllRolePage = () => {
    this.setData({
      isShowAllRole: true
    })
  }
  hiddenAllRolePage = () => {
    this.setData({
      isShowAllRole: false
    })
  }
  showFunList = () => {
    this.setData({
      isShowFunList: true
    })
  }
  hiddenFunList = () => {
    this.setData({
      isShowFunList: false
    })
  }
  bindSearInput = (event) => {
    let val = event.target.value;
    this.setData({
      searchValue: val
    })
  }
  searchRole = () => {
    let val = this.data.searchValue;
    let reg = new RegExp(val);
    let Arr = this.data.roleList.filter(item => {
      if(val == item.role_name || val == item.title || reg.test(item.role_name) || reg.test(item.title)){
        return item
      }
    })
    this.setData({
      roleListAll: Arr
    })
  }
  changeAside = () => {
    this.setData({
      isShowAside: !this.state.isShowAside
    })
  }

  // 获取功能列表
  getFunList = () => {
    if (!this.data.selectedRoleId) {
      return;
    }
    app.sendRequest({
      url: '/index.php?r=ChatAI/getFuncList',
      data: {
        app_id: app.getAppId(),
        page: -1,
        page_size: 1,
        role_id: this.data.selectedRoleId
      },
      method: 'POST',
      success:  (res) => {
        this.setData({
          funList: res.data || [],
        })
      }
    })
  }

  useFunByAI = (event) => {
    let prompt = event.currentTarget.dataset.prompt;
    this.setData({
      content: prompt
    });
    this.goQuestion({
      session_id: this.state.sessionId,
      question: prompt,
      type: this.state.modalType
    })
    this.setData({
      isShowFunList: false
    });
  }
  iconUploadFiles = () => {
    if (this.fileInputRef.current && this.data.filesList.length < 10) {
      this.fileInputRef.current.click();
    }
  }
  removeFile = event => {
    let index = event.currentTarget.dataset.index;
    this.data.filesList.splice(index, 1)
    this.setData({
      filesList: this.data.filesList
    });
  }
  uploadFiles = async (e) => {
    const files = e.target.files;
    const currentFiles = this.data.filesList
    const maxFileSize = 20 * 1024 * 1024; // 20MB
    const maxFiles = 10;

    if (!files.length) {
      return;
    }

    // 检查文件数量
    if (files.length + currentFiles.length > maxFiles) {
      Toast.info(`最多只能上传${maxFiles}个文件！`);
      return;
    }

    // 检查每个文件的大小和类型，并返回详细信息
    const validTypes = new Set([
      'image/jpeg', 'image/png', 'application/msword', 
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
      'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
      'application/pdf', 'application/vnd.ms-powerpoint', 
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'text/plain'
    ]);

    const fileDetails = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxFileSize) {
        Toast.info(`${file.name} 大小超过20MB，无法上传。`);
        continue;
      }

      if (!validTypes.has(file.type)) {
        Toast.info(`${file.name} 类型不支持，无法上传。`);
        continue;
      }

      const type = this.getFileType(file.type);
      const size = this.getFileSize(file.size);

      const fileDetail = {
        name: file.name,
        type: type,
        size: size,
        url: '',
        status: 1
      };

      fileDetails.push(fileDetail);
    }

    this.setData({
      filesList: currentFiles.concat(fileDetails)
    });

    await Promise.all(fileDetails.map(async (fileDetail, index) => {
      const file = files[index];
      try {
        if (fileDetail.type !== 'image') {
          ajax({
            url: '/index.php?r=ChatAI/UploadFile',
            data: {
              name: file
            },
            success: (res) => {
              if (res.status === 0) {
                fileDetail.url = res.data;
                fileDetail.status = 2;
              } else {
                fileDetail.url = '';
                fileDetail.status = 3;
              }
              // if(fileDetail.status == 2){
              //   this.comfirmFile(fileDetail)
              // }
              currentFiles.push(fileDetail)
              this.setData({
                filesList: currentFiles
              });              
            }
          });
        } else {
          const result = await lrz(file);
          ajax({
            url: '/index.php?r=AppData/uploadImg',
            data: {
              img_data: result.base64,
              org: 1
            },
            success: (res) => {
              if (res.status === 0) {
                fileDetail.url = res.data;
                fileDetail.status = 2;
              } else {
                fileDetail.url = '';
                fileDetail.status = 3;
              }
              // if(fileDetail.status == 2){
              //   this.comfirmFile(fileDetail)
              // }
              currentFiles.push(fileDetail)
              this.setData({
                filesList: currentFiles
              });
            }
          });

        }
        
      } catch (error) {
        fileDetail.url = '';
        fileDetail.status = 3;
        currentFiles.push(fileDetail)
        this.setData({
          filesList: currentFiles
        });
      }
    }));
  }

  // 文件确定上传
  comfirmFile = (fileobj)=>{
    const filesListJson = JSON.stringify(fileobj);
    app.sendRequest({
      url: '/index.php?r=ChatAI/Upload2User',
      data: {
        app_id: app.getAppId(),
        session_key: '',
        multi_files:filesListJson,
        role_id:-1
      },
      hideLoading: true,
      method: 'POST',
      success:(res) => {
        // if(res.status == 0){
        //   Toast.success('文件上传成功');
        // }else{
        //   Toast.fail('文件上传失败');
        // }
      }
    })
  }
  
  useComfirmFile = (e)=>{
    this.setData({
      memoryDialogShow:false
    })
    const currentFiles = this.data.filesList
    if(currentFiles.length > 9){
      Toast.info('最多只能添加十个文件图片');
      return
    }
    const fileDetail = {
      name: e.file_name,
      type: e.file_type,
      size: e.file_size,
      url: e.file_url,
      status: 2
    };
    let  fileDetails = []
    fileDetails.push(fileDetail);
    this.setData({
     filesList: currentFiles.concat(fileDetails)
    });
    console.log(this.state.filesList)
    
  }
  // 开启长期记忆多选选择
  // setStorageData = ()=>{
  //   this.setState({
  //     isStorageVisible:true
  //   })
  // }

  // 关闭长期记忆多选选择
  // closeStorage = ()=>{
  //   this.setState({
  //     isStorageVisible:false
  //   })
  //   this.resetStorage()
  // }

  // 全选按钮
  // checkAllboxChange = event => {
  //   let checked = event.target.checked;
  //   this.setState({
  //     isAllStorage: checked
  //   },()=>{
  //     const { dialogueList,isAllStorage } = this.state
  //     const newDialogueList = dialogueList.map(item => ({
  //         ...item,
  //         isStorageFlag: isAllStorage
  //     }));
  //     this.setState({
  //       dialogueList:newDialogueList
  //     })
  //   })
  // }

  // 单选按钮
  // checkboxChange = (ids,flag)=>{
  //   const { dialogueList } = this.state
  //   const newDialogueList = dialogueList.map(item => {
  //       if(item.id == ids) {
  //         return { ...item, isStorageFlag: flag };
  //       }
  //       return item; 
  //   });
  //   const isAllStorage = newDialogueList.every(item => item.isStorageFlag === true);
  //   this.setState({
  //     dialogueList:newDialogueList,
  //     isAllStorage: isAllStorage
  //   })
  // }

  // 添加记忆
  // addStorage = ()=>{
  //   const { dialogueList } = this.state
  //   const newDialogueList = dialogueList.filter(item => item.isStorageFlag === true);
  //   console.log(newDialogueList);
  //   if(newDialogueList.length == 0) {
  //     Toast.info('请先选择对话内容添加到长期记忆');
  //     return
  //   }
  //   this.resetStorage()
    
  // }

  // 清空选择的对话内容
  // resetStorage = ()=>{
  //   const { dialogueList } = this.state
  //   const newDialogueList = dialogueList.map(item => ({
  //       ...item,
  //       isStorageFlag: false
  //   }));
  //   this.setState({
  //     dialogueList:newDialogueList,
  //     isAllStorage:false
  //   })
  // }

  getFileType = (mimeType) => {
    const typeMap = {
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
      'application/pdf': 'pdf',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
      'text/plain': 'txt',
      'application/vnd.ms-excel': 'excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
      'image/jpeg': 'image',
      'image/png': 'image'
    };
  
    return typeMap[mimeType] || mimeType;
  }
  getFileSize = (sizeInBytes) => {
    if (sizeInBytes < 1024) {
      return `${sizeInBytes} B`;
    } else if (sizeInBytes < 1024 * 1024) {
      return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    } else {
      return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
    }
  }

  // 深度解析
  deepSwitchChange = (e)=>{
    this.setData({
      deepSwitch: e
    })
  }
  render() {
    let { canUseIntegral, userInfo, historyList, roleList, roleListAll, selectedRoleId, selectedRoleName, selectedRoleLLM, sessionId, userVipCardInfo, modalName, modalId, modalList, isShowModalConfig, is_more,
      dialogueList, content, searchValue, isSub,memoryDialogShow, integralDialogShow, orderDialogShow, rechargeCenterShow, vipRechargeShow, paySuccessShow, integralRechargeShow, isQuestioning, isShowAllRole,
      isShowAside, isNeedVip, isNeedIntegral, filesList, isShowFunList, funList, deepSwitch, is_use_cot} = this.state;
    return (
      <div className='pcgpt_page'>
        {isShowAside == true ? (
          <div className='aside'>
          <div className='head_l'>
            <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/jisulog2.png" />
          </div>
          <div className='parting_line'></div>
          <div className='ais_con'>
            <div className='history_t'>历史对话</div>
            <div className='history_list'>
            {historyList.map((item, index) =>
              <div className={'history_item ' + (item.isDel?'predel ':'') + (sessionId==item.id?'active':'')} key={index} onClick={this.goHistoryDetail} data-id={item.id} data-rid={item.role_play_id}>
                 {!item.isEdit== true && (
                  <div className='history_item_t'>
                  <img className='diaimg' src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/dialogue2.png"/>
                  <div className='line1'>{item.role_name}</div>
                </div>
                 )}
                
                <div className='history_item_con'>   
                    {item.isEdit?(
                    <div className="edit_line" >
                      <input type="text" onInput={this.bindHisInput} onChange={this.bindHisInput} onClick={this.debubbling} data-id={item.id} value={item.content}/>
                      <label className='pcgpt_label ico-moon icon-gpt-gou' onClick={this.conf} data-id={item.id} data-val={item.content}></label>
                      <label className='pcgpt_label ico-moon icon-gpt-cha mar_l8' onClick={this.noConf} data-id={item.id}></label>
                    </div>
                    ):(
                    <div>
                      <div className='line2'>
                        <span>{item.content}</span>
                          {item.isDel == false && <span style={{width:'34px'}} className="config_span">
                          <label className='pcgpt_label ico-moon icon-gpt-edit' onClick={this.edit} data-id={item.id}></label>
                          <label className='pcgpt_label ico-moon icon-gpt-del mar_l8' onClick={this.preDel} data-id={item.id}></label>
                        </span>}
                      </div>
                    </div>
                    )}
                </div>
                {item.isDel == true && (
                  <div className='del_prompt'>
                    <div className='del_prompt_t'>删除后无法恢复，是否继续删除？</div>
                    <div className='del_prompt_btn'>
                      <div onClick={this.cancelPreDel} data-id={item.id}>取消</div>
                      <div className='btndelete' onClick={this.delect} data-id={item.id}>删除</div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {historyList.length == 0 && <div className='mar_l10'>暂无历史对话</div>}
            </div>
          </div>
          <div className='nav_list'>
            <div className='nav_item' onClick={this.startNewSession}>
              <label className='ico-moon icon-add'></label>
              <span>新建对话</span>
            </div>
            {isNeedIntegral == true && (
              <div className='nav_item' onClick={this.clickNav} data-type='rechargeCenter'>
              <label className='ico-moon icon-points'></label>
              <span>积分充值</span>
            </div>
            )} 
          </div>
          <div className='aside_footer_box'>
            <div className='aside_footer'>
              <label className='ico-moon icon-close' onClick={this.changeAside}></label>
            </div>
          </div>
        </div>
        ):
        (
        <div className='unfold_aside' onClick={this.changeAside}>
          <span>展开</span>
          <label className='ico-moon icon-unfold'></label>
        </div>
        )}
        
        <div className='main'>
          <div className='head'>
            <div className='head_r'>
             <div className='head_item head_item_order' onClick={this.clickNav} data-type='memoryDialog'>
                <img  src="//cdn.jisuapp.cn/static/management/assets/img/ai/basic/term22.png" alt="" />
                <div>记忆</div>
              </div>
              <div className='head_item head_item_order' onClick={this.clickNav} data-type='integralDialog'>
                <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item_6_2.png" />
                <div>积分：{canUseIntegral}分</div>
              </div>
              <div className='head_item head_item_order' onClick={this.clickNav} data-type='orderDialog'>
                <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item_7_2.png" />
                <div>订单记录</div>
              </div>
              {(isNeedVip == true || isNeedIntegral == true) && (
                <div className='head_item head_item_vip' onClick={!userVipCardInfo?this.clickNav:''} data-type='rechargeCenter'>
                  <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog3.png" />
                  {!userVipCardInfo?'立即开通':'会员用户'} 
                </div>
              )}
              <div className='head_item'>
                <img src={userInfo.cover_thumb?userInfo.cover_thumb:'http://img.zhichiwangluo.com/zc_app_default_photo.png'} />
                <div className='logout_box'>
                  <div className='sj'></div>
                  <div className='logout' >
                    <div className='phone'>{userInfo.phone}</div>
                    <div onClick={this.logout}>退出登录</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='session_box'>
            <div className='session_con'>
              <div className='dialog_box' ref={this.myRef} onScroll={this.handleScroll}>
                {!dialogueList.length &&
                <div className="tab_box">
                  <img className="headimg" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/log.png" alt="" />
                  <div className="tab_list">
                    <div className='role_box'>
                      <div className='tabtitle'>
                        <span>选择一个你想对话的角色：</span>
                        <span onClick={this.showAllRolePage} style={{cursor:'pointer'}}>更多<label className='ico-moon little-icon icon-rightarrow'></label></span>
                      </div>
                      <div className='tab_con'>
                      {roleList.map((item, index) => {
                          if(index < 6){
                            return (<div className={'tab ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'role_active' : '')}
                            data-id={item.role_id || item.id} key={index} onClick={this.selectActiveItem}>
                              <div className='tab_dsc'>
                                <div>{item.role_name || item.title}</div>
                                <label className='ico-moon little-icon icon-rightarrow'></label></div>
                              {item.url && <img className='roleimg' src={item.url} />}
                            </div>)
                          }
                        }) 
                      }
                      </div>
                    </div>
                  </div>
                </div>
                }
                {is_more == 1 &&
                  <div className="request-all" onClick={this.getMore}>点击加载更多</div>
                }
                {dialogueList.map((item, index) =>
                  <TextAnimationPc key={item.id + '-' + index} data={item}  againSend={this.againSend} className='head_r' toBoxBottom={this.toBoxBottom} endQuestion={this.endQuestion} showDeepChange={this.showDeepChange} showDeepFinshed={this.showDeepFinshed} />
                )}
              </div>
              {/* {
                !isStorageVisible && <div className='close_field'>
                       <div className='close_box' ref={this.heRef}>
                        <div className="close-lf">
                          <input type="checkbox" checked={isAllStorage} onChange={this.checkAllboxChange} />
                          <span>全选</span>
                        </div>
                        <div className="close-rf">
                           <div className="close-hd">
                             <div className="close-btn" onClick={this.closeStorage}>取消</div>
                             <div className="close-comfirm" onClick={this.addStorage}>添加到记忆</div>
                           </div>
                           <div className="close-bd">
                             内容由AI大模型生成，请仔细甄别！
                           </div>
                        </div>
                       </div>
                </div>
              } */}
             <div className='ipt_field'>
                <div className='tool_box' ref={this.heRef}>
                  <div className='tool'>
                    { !selectedRoleLLM && 
                      <div className='tool_item' onClick={modalList.length>1?this.showSelectModalBox:null}>
                        模型：{modalName}{modalList.length > 1 && (
                          isShowModalConfig ?
                          (<img className='check_mode' src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_top.png" />):
                          (<img className='check_mode' src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_down.png" />)
                        )
                        }
                      </div>
                    }
                    <div className='tool_item'>
                      对话角色：{selectedRoleName} <img className={isShowAllRole?'check_mode check_btn_cha':'check_mode'} onClick={this.showAllRolePage} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_add.png" />
                    </div>
                    { funList.length > 0 &&
                      <div className='tool_item'>
                        功能列表<img className='check_mode' onClick={this.showFunList} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_add.png" />
                      </div>
                    }
                    {is_use_cot && (
                      <div className='tool_item'>
                        深度解析：
                        <Switch 
                          className="switch"
                          checked={deepSwitch}
                          onChange={this.deepSwitchChange}
                        />
                      </div>
                    )}
                  </div>
                  {isShowModalConfig && <div className='tool_config'>
                    {modalList.map((item) =>
                    (
                      item.require_vip_permission == '1' ? (
                        <div className={modalId == item.type?'config_item config_item_vip config_vip_select':'config_item_vip config_item'} key={item.type} 
                          onClick={this.selectModal} data-type={item.type} data-isvip={item.require_vip_permission}>
                            <img className='little-img' src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog3.png" />{GPTModal[item.type]}
                        </div>
                        ):
                        (
                          <div className={modalId == item.type?'config_item config_item_select':'config_item'} key={item.type} 
                            onClick={this.selectModal} data-type={item.type} data-isvip={item.require_vip_permission}>
                              {GPTModal[item.type]}
                          </div>
                        )
                    )
                    )}
                  </div>}
                </div> 
                <div className='ipt_file_list'>
                {filesList.map((item, index) =>
                  <div className='file_item'  key={index} >
                    {
                      item.status === 1 && (
                      <div className='file_loading'>
                        <img className='icon_file' src="https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_file_loading.png" alt="" />
                        <div className="loading-spinner"></div>
                      </div>
                      )
                    }
                    {
                      item.status === 2 && item.type === 'image' &&
                      <img className='icon_file' src={ item.url } alt="" />
                    }
                    {
                      item.status === 2 && item.type !== 'image' &&
                      <img className='icon_file' src={ 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + item.type + '.png' } alt="" />
                    }
                    {
                      item.status === 3 &&
                      <img className='icon_file' src={ 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + (item.type === 'image' ? 'img_fail.png' : 'file_fail.png') } alt="" />
                    }
                  <div className='file_dsc'>
                    <span className='file_name'>{ item.name }</span>
                    { item.status === 1  &&
                      <span className='file_state'>上传中...</span>
                    }
                    { item.status === 2  &&
                      <span className='file_state'>{ item.type }，{ item.size }</span>
                    }
                    { item.status === 3  &&
                      <span className='file_state fail'>上传失败</span>
                    }
                  </div>
                  <label className='ico-moon icon-close-btn' onClick={ this.removeFile } data-index={ index }></label>
                </div>
                )}
                </div>
                <div className='ipt_wrapper'>
                  <textarea id='auto-resize-textarea' className="ipt_box" placeholder={!userVipCardInfo && isNeedIntegral?"来说点什么吧（消耗2积分）":"来说点什么吧"} onKeyPress={this.askQuestionsKeyEnter} onInput={this.bindTextInput} onChange={this.bindTextInput} value={content}/>
                </div>
                <div className='ipt_btns'>
                  <div className={ 'icon_ipt_file ' + ( filesList.length > 9 ? 'disabled' : '') } onClick={ this.iconUploadFiles }><label className='ico-moon icon-comNote'></label></div>
                  <span className='ipt_tips'>支持上传文件(最多10个，每个20 MB)。接受 pdf、doc、ppt、txt、excel、图片等</span>
                  <input type="file" disabled={ filesList.length > 9 } ref={this.fileInputRef}  id="fileInput" multiple accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.txt" onChange={ this.uploadFiles } />
                  <div className={'sub_btn ' + ((isSub && !isQuestioning) || filesList.length?'btn_t':'')} onClick={this.askQuestions} title={isSub && !isQuestioning?'':'说点什么吧'}>{isQuestioning?'回答中':'发送'}</div>
                </div>
              </div>
              
             
            </div> 
          </div>
        </div>
        {
          isShowAllRole == true &&
          <div className='drawer_box'>
            <div className='mask' onClick={this.hiddenAllRolePage}></div>
            <div className='drawer_bth' onClick={this.hiddenAllRolePage}>收起</div>
            <div className='drawer'>        
              <div className='head'>
                <div className='title'>角色切换</div>
                <div className='ipt_box'>
                  <input type="text" value={searchValue} onInput={this.bindSearInput} onChange={this.bindSearInput} onClick={this.debubbling}/>
                  <div onClick={this.searchRole}><label className='ico-moon icon-search'></label>搜索</div>
                </div>
              </div>
              <div className='main'>
              {roleListAll.map((item, index) => {
                return (<div className={'role_item ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'active' : '')}
                data-id={item.role_id || item.id} key={index} onClick={this.selectActiveItem}>
                  {item.url && <img src={item.url} />}
                  <div>{item.role_name || item.title}</div>
                </div>)
              })}
              </div>
            </div>
          </div>
        }

        {
          isShowFunList == true &&
          <div className='drawer_box fun'>
            <div className='mask' onClick={this.hiddenFunList}></div>
            <div className='drawer_bth' onClick={this.hiddenFunList}>收起</div>
            <div className='drawer'>        
              <div className='head'>
                <div className='title'>功能列表</div>
              </div>
              <div className='main'>
              {funList.map((item, index) => {
                return (<div className='role_item'
                data-prompt={item.prompt} key={index} onClick={this.useFunByAI}>
                  {item.icon && <img src={item.icon} />}
                  <div className='fun_name'>{item.name}</div>
                </div>)
              })}
              </div>
            </div>
          </div>
        }
        
        {integralDialogShow == true && <IntegralDetail cancelDialog={this.cancelDialog} />}
        {orderDialogShow == true && <OrderList cancelDialog={this.cancelDialog} />}
        {vipRechargeShow == true && <VipRecharge cancelDialog={this.cancelDialog}/>}
        {integralRechargeShow == true && <IntegralRecharge cancelDialog={this.cancelDialog}/>}
        {paySuccessShow == true && <PaySuccess cancelDialog={this.cancelDialog}/>}
        {rechargeCenterShow == true && <RechargeCenter cancelDialog={this.cancelDialog}/>}
        {memoryDialogShow == true && <MemoryBank cancelDialog={this.cancelDialog} useComfirmFile={this.useComfirmFile} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/pc-index/PcIndex.jsx